import StyleSheetRW from "core/StyleSheetRW";

export const AddProjectFormStyles = StyleSheetRW.create(() => ({
    overlay: {
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
        overflow: 'hidden',
    },
    dialog: {
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: 8,
        width: "299px",
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        position: "relative"
    },
    heading: {
        margin: 0,
        marginBottom: 10,
        fontFamily: "Outfit",
        fontSize: 20,
        fontWeight: "bold",
        textAlign: "left",
        color: "#333333",
    },
    label: {
        fontFamily: "Outfit",
        fontSize: 14,
        fontWeight: "600",
        textAlign: "left",
        width: "100%",
        marginTop: 10,
        marginBottom: 5,
        color: "#333333",
    },
    input: {
        height: 40,
        borderRadius: 10,
        paddingLeft: 10,
        paddingRight: 10,
        backgroundColor: "#0000000D",
        marginTop: 3,
        fontFamily: "Outfit",
        fontSize: 14,
        fontWeight: "400",
        color: "#333333",
        border: 0
    },
    inputContainer: { display: "flex", flexDirection: "column" },
    button: {
        marginTop: 10,
        backgroundColor: "#2F4858",
        alignSelf: "center",
        borderRadius: 100,
        color: "white",
        fontWeight: "300",
        textAlign: "center",
        borderWidth: 0,
        width: "100%",
        height: "38px",
        cursor: "pointer",
    },
    buttoneStyle: {
        backgroundColor: "#8c9ea2",
        borderRadius: 99,
        fontWeight: "lighter",
        fontSize: "14px",
        color: "white",
        width: "110px",
        height: "37px",
        border: "0",
        cursor: "pointer",
    },
    closeButton: {
        position: "absolute",
        top: 23,
        right: 15,
        backgroundColor: "transparent",
        border: 0,
        cursor: "pointer",
    },
    error: {
        color: 'red',
        fontSize: '12px',
        marginTop: '13px',
    }
}));